module.exports = __webpack_public_path__ + "img/shell.7934b1c9.jpeg";